import { render, staticRenderFns } from "./create-organisation.vue?vue&type=template&id=63f94194&scoped=true"
import script from "./create-organisation.vue?vue&type=script&lang=ts"
export * from "./create-organisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f94194",
  null
  
)

export default component.exports